import React from "react";
import { Link } from "react-router-dom";
import "../styles/no-route.css";

const NoRoute = () => {
  return (
    <div className="content-center">
      <div>
        <h2>Content Not Found</h2>
        <p>The content you are looking for does not exist on Gainss. Please verify the URL or navigate back to the main page.</p>
        <Link to="/dashboard">Back to dashboard</Link>
      </div>
    </div>
  );
};

export default NoRoute;
